import { State as ParticipantState } from '@wix/ambassador-challenges-v1-participant/types';
import { TranslateFunction } from '@wix/challenges-web-library';
import {
  IUserType,
  UserState,
} from '../../../../../../../../../contexts/User/UserContext';
import { isUserJoinedAlready } from '../../../../../../../../../contexts/User/helpers/userTypeHandlers';

interface IGetJoinButtonTextProps {
  t: TranslateFunction;
  userType: IUserType;
  isAvailableForJoinImmediately: boolean;
  joinButtonTextFromSettings: string;
  requestToJoinButtonTextSettings: string;
}

export function getJoinButtonText(args: IGetJoinButtonTextProps): string {
  const {
    t,
    userType,
    isAvailableForJoinImmediately,
    joinButtonTextFromSettings,
    requestToJoinButtonTextSettings,
  } = args;

  if (isUserJoinedAlready(userType)) {
    return t('challenge-card.view-button');
  }

  switch (userType) {
    case UserState.VISITOR:
    case UserState.MEMBER:
    case ParticipantState.JOIN_REJECTED:
    case ParticipantState.LEFT:
    case ParticipantState.REMOVED:
    case ParticipantState.COMPLETED:
    case ParticipantState.FAILED:
    case ParticipantState.JOINED:
    case ParticipantState.RUNNING:
      return isAvailableForJoinImmediately
        ? joinButtonTextFromSettings
        : requestToJoinButtonTextSettings;
    case ParticipantState.JOIN_REQUESTED:
      return t('challenge.join-request.cancel');
    case ParticipantState.INVITED:
    case ParticipantState.PAYMENT_REQUESTED:
    case ParticipantState.PAYMENT_STARTED:
    default:
      return joinButtonTextFromSettings;
  }
}
